import { render } from "./QuickChat.vue?vue&type=template&id=f1d9a864"
import script from "./QuickChat.vue?vue&type=script&lang=js"
export * from "./QuickChat.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__